import h from 'react-hyperscript';

const Admin = () => {
    return (
        h('div', {}, [
            h('p', {}, 'admin yo')
        ])
    );
};

export default Admin;



/** WEBPACK FOOTER **
 ** ./src/Admin/index.js
 **/